import { ReactNode } from "react";
import Tooltip from "@components/Tooltip";
import { Typography } from "@kelp-dao/kernel-design-system";

interface SummaryItem {
  label: string | ReactNode;
  value: string | ReactNode;
  condition?: boolean;
  tooltip?: string | ReactNode;
}

interface TransactionSummaryProps {
  items: SummaryItem[];
  className?: string;
}

const TransactionSummary = ({
  items,
  className = "",
}: TransactionSummaryProps) => {
  return (
    <div className="mt-5">
      {/* <div className={`mt-8 md:mt-6 ${className}`}> */}
      {items
        .filter((item) => {
          // Show item if condition is undefined (default) or explicitly true
          // Hide item only if condition is explicitly false
          return item.condition !== false;
        })
        .map((item, index) => {
          return (
            <div
              key={index}
              className={`flex justify-between items-center mt-2 ${className}`}
            >
              <div className="flex gap-2 items-center text-[12px] md:text-[14px]">
                {typeof item.label === "string" ? (
                  <Typography
                    type="body"
                    variant="xsmall"
                    className="text-text-secondary text-[12px] md:text-[14px]"
                  >
                    {item.label}
                  </Typography>
                ) : (
                  item.label
                )}
                {item.tooltip && (
                  <Tooltip
                    label={
                      typeof item.tooltip === "string" ? (
                        <span>{item.tooltip}</span>
                      ) : (
                        item.tooltip
                      )
                    }
                  />
                )}
              </div>
              <div className="text-right text-[12px] md:text-[14px]">
                {typeof item.value === "string" ||
                typeof item.value === "number" ? (
                  <Typography
                    type="body"
                    variant="xsmall"
                    className="text-text-primary md:text-[14px]"
                  >
                    {item.value}
                  </Typography>
                ) : (
                  item.value
                )}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default TransactionSummary;
